import React from 'react';
import { Input, Button } from 'antd';

interface ColorInputProps {
    value: string;
    onChange: (color: string) => void;
}

export const ColorInput: React.FC<ColorInputProps> = ({ value, onChange }) => {
    const isTransparent = value === 'transparent' || value === 'rgba(0,0,0,0)' || value === '';

    return (
        <div className="color-input-wrapper">
            <div className="color-preview" style={{
                backgroundColor: isTransparent ? 'transparent' : value,
                backgroundImage: isTransparent ? 'linear-gradient(45deg, #ccc 25%, transparent 25%), linear-gradient(-45deg, #ccc 25%, transparent 25%), linear-gradient(45deg, transparent 75%, #ccc 75%), linear-gradient(-45deg, transparent 75%, #ccc 75%)' : 'none',
                backgroundSize: isTransparent ? '8px 8px' : 'auto',
                backgroundPosition: isTransparent ? '0 0, 0 4px, 4px -4px, -4px 0px' : 'auto'
            }}>
                <input
                    type="color"
                    value={isTransparent ? '#ffffff' : value}
                    onChange={(e) => onChange(e.target.value)}
                    disabled={isTransparent}
                />
            </div>
            <Input
                value={value}
                onChange={(e) => onChange(e.target.value)}
                placeholder="#000000"
                style={{ flex: 1, fontWeight: 600 }}
                size="small"
            />
            <Button
                size="small"
                type={isTransparent ? 'primary' : 'default'}
                onClick={() => onChange(isTransparent ? '#000000' : 'transparent')}
                style={{
                    minWidth: '60px',
                    fontWeight: 600,
                    fontSize: '10px'
                }}
                title={isTransparent ? 'Switch to color' : 'Make transparent'}
            >
                {isTransparent ? 'COLOR' : 'CLEAR'}
            </Button>
        </div>
    );
};